import equal from 'fast-deep-equal';
import { create } from 'zustand';

type LetterTemplate = {
  id: string;
  name: string;
  content: string;
  header: string;
  subheader: string;
  category_id: string;
};

type UseSelectedLetterTemplateStore = {
  selectedLetterTemplates: Record<string, LetterTemplate>;
  updateSelectedLetterTemplate: (
    templateId: string,
    template: LetterTemplate,
  ) => void;
  getSelectedLetterTemplate: (templateId: string) => LetterTemplate | null;
  resetSelectedLetterTemplates: () => void;
  hasChanged: (templateId: string, originalTemplate: LetterTemplate) => boolean;
};

const useSelectedLetterTemplateStore = create<UseSelectedLetterTemplateStore>(
  (set, get) => ({
    selectedLetterTemplates: {},

    updateSelectedLetterTemplate: (templateId, template) =>
      set((state) => ({
        selectedLetterTemplates: {
          ...state.selectedLetterTemplates,
          [templateId]: template,
        },
      })),

    getSelectedLetterTemplate: (templateId) =>
      get().selectedLetterTemplates[templateId] || null,

    resetSelectedLetterTemplates: () => set({ selectedLetterTemplates: {} }),

    hasChanged: (templateId, originalTemplate) =>
      !equal(get().selectedLetterTemplates[templateId], originalTemplate),
  }),
);

export const useSelectedLetterTemplate = (templateId: string) =>
  useSelectedLetterTemplateStore((state) =>
    state.getSelectedLetterTemplate(templateId),
  );

export const updateSelectedLetterTemplate = (
  templateId: string,
  template: LetterTemplate,
) =>
  useSelectedLetterTemplateStore
    .getState()
    .updateSelectedLetterTemplate(templateId, template);

export const resetSelectedLetterTemplates = () =>
  useSelectedLetterTemplateStore.getState().resetSelectedLetterTemplates();

export const hasLetterTemplateChanged = (
  templateId: string,
  originalTemplate: LetterTemplate,
) =>
  useSelectedLetterTemplateStore
    .getState()
    .hasChanged(templateId, originalTemplate);
